import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

export default function useValidateDupeMember(watch: any, fetchMembers: any, isCreate: boolean) {
  const [showWarningModal, setShowWarningModal] = useState<boolean>(
    isCreate && process.env.REACT_APP_MEMBER_POPUP === 'Y'
  );
  const [firstNm, lastNm, dob, effectiveStartDt] = watch(['firstNm', 'lastNm', 'dob', 'effectiveStartDt']);

  useEffect(() => {
    if (!isCreate) {
      setShowWarningModal(false);
      return;
    }

    const validateDateOfBirth = (dob: string): boolean => {
      const date = new Date(dob);
      return !isNaN(date.getTime());
    };

    const checkForDuplicateMember = async () => {
      if (firstNm && lastNm && dob && effectiveStartDt) {
        if (!validateDateOfBirth(dob)) {
          return;
        }

        const [month, day, year] = dob.split('/');
        const formattedDob = `${year}-${month}-${day}`;

        try {
          const searchParams = {
            firstName: firstNm.trim().toLowerCase(),
            lastName: lastNm.trim().toLowerCase(),
            dob: formattedDob
          };

          const response = await fetchMembers({ search: searchParams });

          if (response.membersSearch && response.membersSearch.length > 0) {
            const exactMatch = response.membersSearch.some(
              (member: any) =>
                member.firstName.trim().toLowerCase() === firstNm.trim().toLowerCase() &&
                member.lastName.trim().toLowerCase() === lastNm.trim().toLowerCase()
            );

            if (exactMatch) {
              setShowWarningModal(true);
            } else {
              console.log('no exact match found');
            }
          }
        } catch (error) {
          console.error('Error fetching members:', error);
          if (error instanceof Error) {
            toast.error('Error fetching members.');
          } else {
            toast.error('An unknown error occurred.');
          }
        }
      }
    };

    if (firstNm && lastNm && dob && effectiveStartDt) {
      checkForDuplicateMember();
    }
  }, [firstNm, lastNm, dob, fetchMembers, effectiveStartDt, isCreate, setShowWarningModal]);

  const userDetails = { firstNm, lastNm, dob };
  return { showWarningModal, setShowWarningModal, userDetails };
}
